/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { getNewExpectedDosages } from "parog-web/components/bio-exam-results/utils/dosage-expected";
import getReferenceValuesMessage from "parog-web/components/bio-exam-results/utils/reference-value-message";
import type Patient from "parog-web/models/patient";
import trimLoincCode from "parog-web/utils/trim-loinc-code";

import styles from "./index.module.css";
interface Signature {
  Args: {
    isAdhoc?: unknown;
    code: string;
    patient: Patient;
  };
}

export default class BioExamResultsSummaryRowComponent extends Component<Signature> {
  styles = styles;

  @service declare store: Store;

  /**
   * The label that should be displayed in the first cell of the row
   * */
  get label() {
    if (this.args.code == "11475-1") {
      return "Germe ECBU";
    }

    const record = this.store.peekRecord(
      "loinc",
      trimLoincCode(`LOINC-${this.args.code}`)
    );

    return record?.displayLabel;
  }

  get patient() {
    return this.args.patient;
  }

  get code() {
    return this.args.code;
  }

  get lastDosageChangedJE() {
    return this.patient.bioExamExpectedDosageChangedJournalEvent;
  }

  get dosageChangedValueMessage(): string | undefined {
    const newExpectedDosages = getNewExpectedDosages(this.patient);
    if (
      newExpectedDosages == undefined ||
      newExpectedDosages[`LOINC-${this.code}`] == undefined
    )
      return undefined;

    return (
      "T0 : " +
      getReferenceValuesMessage({
        min: newExpectedDosages[`LOINC-${this.code}`]?.minReferenceValue,
        max: newExpectedDosages[`LOINC-${this.code}`]?.maxReferenceValue,
        prefix: ""
      })
    );
  }
}
